import Container from '../components/common/Container';
import PageHeader from '../components/common/PageHeader';

const Dashboard = () => {
  return <Container></Container>;
};

export default Dashboard;
